import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { ButtonBase } from '#src/atoms/buttons/ButtonBase/index.tsx';
import { ProIcon } from '#src/atoms/icons/Pro.tsx';
import { WinterRound } from '#src/atoms/icons/WinterRound.tsx';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { LabelL } from '#src/atoms/typography/index.tsx';
import { useSportContext } from '#src/contexts/sport/index.ts';
import { useSeriesNav } from '#src/hooks/commonGame/useSeriesNav.ts';
import { useLockProMode } from '#src/hooks/useLockProMode.ts';
import { useUnlockProMode } from '#src/hooks/useUnlockProMode.ts';

const Root = styled(Horizontal)`
  width: 100%;
  border-radius: var(--unit);
  background: var(--c-nd-50);
  padding: var(--half-unit);

  & > * {
    flex: 1;
  }

  &.collapsed {
    flex-direction: column;
  }
`;
const ToggleItem = styled(Horizontal).attrs({ center: true })`
  border-radius: calc(var(--unit) - 2px);
  padding: var(--unit);

  &.selected {
    background: var(--c-black);
  }
`;

type Props = {
  collapsed?: boolean;
};
export const ProSetToggle = ({ collapsed }: Props) => {
  const { sport } = useSportContext();
  const seriesNav = useSeriesNav();
  const { unlockProMode } = useUnlockProMode();
  const { lockProMode } = useLockProMode();

  return (
    <Root className={classNames({ collapsed })}>
      <ButtonBase
        onClick={() => {
          lockProMode({
            variables: {
              sport,
              input: {
                sport,
                interactionContext: 'user-nav',
              },
            },
          });
        }}
      >
        <ToggleItem className={classNames({ selected: seriesNav })}>
          <WinterRound />
          {!collapsed && (
            <LabelL>
              <FormattedMessage
                id="ProSetToggleNavItem.set"
                defaultMessage="Set"
              />
            </LabelL>
          )}
        </ToggleItem>
      </ButtonBase>
      <ButtonBase
        onClick={() => {
          unlockProMode({
            variables: {
              sport,
              input: {
                sport,
                interactionContext: 'user-nav',
              },
            },
          });
        }}
      >
        <ToggleItem className={classNames({ selected: !seriesNav })}>
          <ProIcon />
          {!collapsed && (
            <LabelL>
              <FormattedMessage
                id="ProSetToggleNavItem.pro"
                defaultMessage="Pro"
              />
            </LabelL>
          )}
        </ToggleItem>
      </ButtonBase>
    </Root>
  );
};
